import { FC } from "react";

import { PullQuoteBlockProps } from "./PullQuoteBlock.type";

const PullQuoteBlock: FC<PullQuoteBlockProps> = ({ data, id }) => {
	const { text, attribution } = data;

	return (
		// Indented to start where the text column does, so the quote lines up with the copy it
		// was lifted from and runs to the same right edge. The offset mirrors the foreword
		// layout in TextWithImageBlock: a `sm:w-1/3` image column plus the row's `gap-8`.
		// Full width on phones, where the portrait stacks above the text and there is no
		// column to align to.
		<figure id={id} className="border-l-4 border-primary pl-6 md:pl-8 py-1 sm:ml-[calc(33.3333%+2rem)]">
			{/* `secondary` rather than `primary`: the light brand blue only reaches ~2.4:1 on
			    white, which fails as text. It carries the rule instead. */}
			<blockquote
				className="text-xl md:text-2xl leading-relaxed font-light text-secondary"
				dangerouslySetInnerHTML={{ __html: text }}
			/>
			{typeof attribution === "string" && attribution.trim().length > 0 && (
				<figcaption
					className="mt-3 text-sm uppercase tracking-wide text-gray-500"
					dangerouslySetInnerHTML={{ __html: attribution }}
				/>
			)}
		</figure>
	);
};

export { PullQuoteBlock };
